export default "__VITE_ASSET__D$ADnoNG__"